import { render, staticRenderFns } from "./priceslider.vue?vue&type=template&id=cabb87bc&"
import script from "./priceslider.vue?vue&type=script&lang=js&"
export * from "./priceslider.vue?vue&type=script&lang=js&"
import style0 from "./priceslider.vue?vue&type=style&index=0&id=cabb87bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports